// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","adminFooter":"Footer_adminFooter__CI2uH","loggedInAdmin":"Footer_loggedInAdmin__NaZO5"};